import { render } from "./EmployeeEducation.vue?vue&type=template&id=098e0a1b"
import script from "./EmployeeEducation.vue?vue&type=script&lang=js"
export * from "./EmployeeEducation.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__